import { render } from "./DocumentDisplay.vue?vue&type=template&id=1d38af2b"
import script from "./DocumentDisplay.vue?vue&type=script&lang=js"
export * from "./DocumentDisplay.vue?vue&type=script&lang=js"

import "./DocumentDisplay.vue?vue&type=style&index=0&id=1d38af2b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__